import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import * as Yup from 'yup';
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { object, ref, string } from "yup";
import { useRegisterMutation } from "../../Store/Services/AuthService";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import styles from '../../Styles/util.module.css';

const schema = object({
    userFirstName: string().trim().required("Please enter your First Name"),
    userLastName: string().trim().required("Please enter your Last Name"),
    userEmail: string()
      .trim()
      .email("Please enter a valid Email!")
      .required("Please enter Email "),
    userPsw: Yup.string()
      .min(8, "The password should be between 8-12 characters.")
      .required("Please enter Password ")
      .max(12, "The password should be between 8-12 characters.")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Password must be more than 8 characters and at least with 1 uppercase 1 lowercase 1 number and 1 special character."
      ),
    confirmPassword: Yup.string()
    .oneOf([Yup.ref('userPsw'), null], 'Passwords must match'),
  });
  
  const SignUpForm = ({ onSuccess }) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      mode: "all",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [triggerRegister, { isLoading }] = useRegisterMutation();
    const navigate = useNavigate();
  
    const handleClickShowPassword = () => {
      setShowPassword((currentShowState) => !currentShowState);
    };
  
    const onSubmit = async (data) => {
      delete data.confirmPassword;
      const obj = {
        orgId: 1,
        ...data,
      };
  
      try {
        const result = await triggerRegister(obj).unwrap();
        onSuccess();
        toast.success("You can sign in now with your provided credential", { position: "bottom-right" });
        // return result;
      } catch (err) {
        console.error(err);
        if(err.status===400){
          toast.error(err.data?._embedded?.errors[0]?.message, {position: "bottom-right"});
        }
      }
    };
  
    return (
      <form
        className={styles.formItem}
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <div style={{ padding: " 0 0  5px 0" }}>
          <TextField
            {...register("userFirstName")}
            label={
              <span>
                
                <span style={{ color: "black" }}>First Name</span>
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            size="small"
            multiline
            rows={1}
            fullWidth
            error={!!errors.userFirstName}
            helperText={errors.userFirstName?.message}
          />
        </div>
  
  
        <div style={{ padding: "5px 0" }}>
          <TextField
            {...register("userLastName")}
            label={
              <span>
                
                <span style={{ color: "black" }}>Last Name</span>
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            size="small"
            multiline
            rows={1}
            fullWidth
            error={!!errors.userLastName}
            helperText={errors.userLastName?.message}
          />
        </div>
        <div style={{ padding: "5px 0" }}>
          <TextField
            {...register("userEmail")}
            label={
              <span>
                
                <span style={{ color: "black" }}>Email</span>
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            size="small"
            multiline
            rows={1}
            fullWidth
            error={!!errors.userEmail}
            helperText={errors.userEmail?.message}
          />
        </div>
        {/* <div item md={6} xs={12}>
            <TextField
              {...register("userTelephone")}
              label="Telephone Number"
              size="small"
              multiline
              rows={1}
              fullWidth
            />
          </div>
          <div item md={6} xs={12}>
            <TextField
              {...register("userMobile")}
              label="Mobile Number"
              size="small"
              multiline
              rows={1}
              fullWidth
            />
          </div> */}
  
        <div style={{ padding: "5px 0" }}>
          <TextField
            {...register("userPsw")}
            label={
              <span>
                
                <span style={{ color: "black" }}>Password</span>
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            size="small"
            autocomplete="off"
            readonly
            onfocus="this.removeAttribute('readonly');"
            id="new-password"
            fullWidth
            // multiline
            rows={1}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    // onMouseDown={handleMouseDownPassword}
                    edge="end"
                    aria-label="Show password"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!!errors.userPsw}
            helperText={errors.userPsw?.message}
          />
        </div>
        <div style={{ padding: "5px 0" }}>
          <TextField
            {...register("confirmPassword")}
  
            label={
              <span>
                
                <span style={{ color: "black" }}>Confirm Passowrd</span>
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            size="small"
            fullWidth
            // multiline
            rows={1}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    // onMouseDown={handleMouseDownPassword}
                    edge="end"
                    aria-label="Show password"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
          />
        </div>
        <div style={{ padding: "5px 0" }}>
          {/* <Typography variant="body1">
              By Creating an account, you agree to our User Agreement and
              acknowledge reading our Privacy Policy.
            </Typography> */}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={isLoading}
            style={{ margin: "3px 0" }}
            aria-label="Sign Up"
          >
            Sign Up
          </Button>
        </div>
        {/* <div>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <IconButton>
              <GoogleIcon />
            </IconButton>
            <IconButton>
              <FacebookRoundedIcon />
            </IconButton>
            <IconButton>
              <GoogleIcon />
            </IconButton>
          </div>
        </div> */}
      </form>
    );
  };
  
  export default SignUpForm;
  